import {
  IDENTITY_PROFILE,
  LOGIN_TYPE,
  USER_CONSENT_DATA
} from "./constants";

const INIT_STATE = {
  identityProfile: null,
  loginType: null,
  userConsentData:null
};

const identityReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case IDENTITY_PROFILE:
      return {
        ...state,
        identityProfile: action.payload,
      };
    case LOGIN_TYPE:
      return {
        ...state,
        loginType: action.payload,
      };
    case USER_CONSENT_DATA:return {
      ...state,
      userConsentData:action.payload
    }
    default:
      return state;
  }
};

export default identityReducer;
